import { boldSchema } from "./bold";
import { codeSchema } from "./code";
import { colorSchema } from "./color";
import { highlightSchema } from "./highlight";
import { italicSchema } from "./italic";
import { linkSchema } from "./link";
import { strikethroughSchema } from "./strikethrough";
import { subscriptSchema } from "./subscript";
import { superscriptSchema } from "./superscript";
import { underlineSchema } from "./underline";

const formats = {
  bold: boldSchema,
  italic: italicSchema,
  underline: underlineSchema,
  subscript: subscriptSchema,
  superscript: superscriptSchema,
  strikethrough: strikethroughSchema,
  highlight: highlightSchema,
  code: codeSchema,
  color: colorSchema,
  link: linkSchema,
};

export { formats };
